import { ServiceTitanIconLink } from "@/core/components/service-titan-icon-link";
import type { ApDocumentType } from "@/accounts-payable/types";
import { stFilingTarget } from "@/accounts-payable/utils";
import { MatchedJobLink } from "./matched-job-link";

/**
 * Links a document's ServiceTitan job (through `MatchedJobLink`, so an
 * invoice links its ST invoice), or the project it is filed on when it has no
 * job. Renders nothing for a document on neither.
 */
export const StFilingTargetLink = ({
  document,
  documentType = "invoice",
  short = false,
  className,
}: {
  document: {
    st_job_external_id?: number | null;
    st_job_number?: string | null;
    st_project_external_id?: number | null;
  };
  documentType?: ApDocumentType;
  /** "Proj #" rather than "Project #", beside the list columns' "Job #" and "Inv #". */
  short?: boolean;
  className?: string;
}) => {
  const target = stFilingTarget(document);
  if (!target) return null;

  if (target.kind === "job")
    return (
      <MatchedJobLink
        jobId={target.id}
        jobNumber={document.st_job_number}
        documentType={documentType}
        className={className}
      />
    );

  return (
    <ServiceTitanIconLink
      url={target.url}
      label={`Open project #${target.id} in ServiceTitan`}
      stopPropagation
      className={className}
    >
      {short ? `Proj #${target.id}` : target.label}
    </ServiceTitanIconLink>
  );
};
